import styled from 'styled-components'

export const Container = styled.div`
  width: 640px;
  display: flex;
  flex-direction: column;
  margin-top: 20px;
  padding: 0px 20px;
  gap: 15px;
`

export const InfoText = styled.p`
  font-size: 14px;
  color: #000000;
  margin: 0px;
`